import React, { useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faPen } from '@fortawesome/free-solid-svg-icons';
import AgeOptionList from './AgeOptionList';
import { useOutsideClick } from '../../hooks/useOutsideClick';
import { MAX_COMBINED_AGES, rankingAgeOptions } from '../../../services/utils/ageCalculation';
/**
 * Defines the one combined age group a swimmer may be ranked against in addition to their own
 * year - the swimming equivalent of the county's '10-11' bracket, but chosen rather than assumed.
 *
 * Selecting only the swimmer's own age means "no combined group", which is how the group is
 * removed: there is no separate delete control.
 */
const CombinedAgeGroupEditor = ({ ownAge, value, onChange, disabled }) => {
    const [open, setOpen] = useState(false);
    const wrapperRef = useRef(null);
    useOutsideClick(wrapperRef, open, () => setOpen(false));
    // The own age always shows as ticked so it is part of any group.
    const selected = value?.length ? value : [ownAge];
    const hasGroup = !!value?.length;
    return (React.createElement("div", { className: "age-group-inline", ref: wrapperRef },
        React.createElement("button", { type: "button", className: "age-group-affordance", onClick: () => setOpen(o => !o), disabled: disabled, "aria-haspopup": "listbox", "aria-expanded": open, "aria-label": hasGroup ? 'Edit combined age group' : 'Add a combined age group', title: hasGroup ? 'Change which ages are combined' : `Also rank against up to ${MAX_COMBINED_AGES - 1} nearby ages` },
            React.createElement(FontAwesomeIcon, { icon: hasGroup ? faPen : faPlus }),
            hasGroup && React.createElement("span", null, "Edit")),
        open && (React.createElement("div", { className: "age-multiselect-popover age-multiselect-popover-anchored", role: "listbox", "aria-multiselectable": "true" },
            React.createElement(AgeOptionList, { options: rankingAgeOptions(ownAge), selected: selected, onChange: ages => {
                    const next = [...new Set([...ages, ownAge])].sort((a, b) => a - b);
                    onChange(next.length > 1 ? next : undefined);
                }, lockedAge: ownAge, maxSelected: MAX_COMBINED_AGES })))));
};
export default CombinedAgeGroupEditor;
